import dynamic from 'next/dynamic';
import css from './index.module.scss';
import A from './components/A';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function SolarPanel60W({ tab }: any) {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`${css['solar-60w-H5']} solar-60w-H5`}>
            <A />
            <IndexDynamic />
        </div>
    );
}
